import Config from "config";
import React, { useEffect } from "react";
import {
  groupDataBy
} from "../common/Common";
import { ModalDetail } from "./common";

const pagesLink = Config.pagesLink;

function getFullMediaURL(mediaPath) {
  if (mediaPath.charAt(0) !== "/") {
    mediaPath = "/" + mediaPath;
  }

  const fullPath = Config.mediaURLPrefix + mediaPath;

  return fullPath;
}

export const IdeaDecoration = React.memo((props) => {
  const propertyDetail = props.propertyDetail;
  const AIImg = propertyDetail.AIImg;

  const temp = groupDataBy(AIImg, "MediaType");
  const IdeaDecTemp = Object.keys(temp).map((MediaType) => ({
    MediaType,
    MediaPath: temp[MediaType],
  }));

  function rearrangeMediaTypes(mediaArray, order) {
    return order.map(type => mediaArray.find(media => media.MediaType === type))?.filter(x=>x);
  }

  function capitalizeFirstLetter(arr) {
    return arr.map(obj => {
        obj.MediaType = obj.MediaType.charAt(0).toUpperCase() + obj.MediaType.slice(1);
        return obj;
    });
  }

  const order = ["modern", "minimal", "loft"];
  const IdeaDec = capitalizeFirstLetter(rearrangeMediaTypes(IdeaDecTemp, order));

  let addtion = propertyDetail.addtion;

  let tab = [];
  let tabDetail = [];

  let tabModal = [];

  if (Array.isArray(IdeaDec) && IdeaDec.length > 0) {
    IdeaDec.map((item, index) => {
      const id = item.MediaType;
      tab.push(
        <li
          data-kbct="click" data-kblb={`group-${item.MediaType}`} data-kbgp="decoration" data-kbsc="decoration" data-kbid={propertyDetail.PropertyID}
          className={`g-tab-list ${index === 0 ? "active" : ""}`}
          role="tab"
          key={"IdeaDec-" + id}
        >
          <span>{item.MediaType}</span>
        </li>
      );

      tabDetail.push(
        <>
          <div key={"IdeaDecDetail-" + id} className={`g-content ${index === 0 ? "active" : ""}`}>
            <div id={`idea-slide-${index + 1}`} className="idea-list">
              <div className="swiper-wrapper">
                {item.MediaPath.map((obj, index) => {
                  var img = getFullMediaURL(obj.MediaPath);
                  return (
                    <div key={"IdeaDecDetail" + img + addtion} className="swiper-slide">
                      <article className="g-wrapper">
                        <div className="thumb">
                          <img className="hide-w1024" src={img} alt="Image" data-kbct="open_popup" data-kblb="gallery" data-kbgp="decoration" data-kbsc="decoration" data-kbid={propertyDetail.PropertyID} />
                          <img className="show-w1024" src={img} alt="Image" data-kbct="open_popup" data-kblb="gallery" data-kbgp="decoration" data-kbsc="decoration" data-kbid={propertyDetail.PropertyID} />
                        </div>
                      </article>
                    </div>
                  );
                })}
              </div>
              <div className="swiper-pagination" />
            </div>
            <div id={`idea-thumb-${index + 1}`} className="idea-thumb">
              <div className="swiper-wrapper">
                {item.MediaPath.map((obj, index) => {
                  var img = getFullMediaURL(obj.MediaPath);
                  return (
                    <div className="swiper-slide" key={"IdeaDecDetail2" + img + addtion}>
                      <div className="thumb">
                        <img className="thumb" src={img} alt="Test Img" 
                          data-kbct="click" data-kblb="thumbnail" data-kbgp="decoration" data-kbsc="decoration" data-kbid={propertyDetail.PropertyID}/>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="swiper-button-next" />
              <div className="swiper-button-prev" />
              <div className="swiper-pagination" />
            </div>
          </div>
        </>
      );

      tabModal.push(
        <>
          <div key={"IdeaDecModalDetail-" + id} className={`g-content ${index === 0 ? "active" : ""}`}>
            <div id={`idea-swiper-${index + 1}`} className="swiper idea-swiper">
              <div className="swiper-wrapper">
                {item.MediaPath.map((obj, index) => {
                  var img = getFullMediaURL(obj.MediaPath);
                  return (
                    <div key={"IdeaDecModalDetail" + img + addtion} className="swiper-slide">
                      <img className="promo-img" src={img} alt="Promotion" />
                    </div>
                  );
                })}
              </div>
              <div className="swiper-button-next" data-kbct="click" data-kblb="swap_photo" data-kbgp="decoration" data-kbsc="decoration" data-kbid={propertyDetail.PropertyID}/>
              <div className="swiper-button-prev" data-kbct="click" data-kblb="swap_photo" data-kbgp="decoration" data-kbsc="decoration" data-kbid={propertyDetail.PropertyID}/>
              <div className="g-name-property show-w1024">
                  <span>หมายเหตุ : ภาพดังกล่าวไม่ใช่ภายจริงแต่ถูกสร้างขึ้นด้วย AI</span>
                  <div className="g-page"></div>
              </div>
            </div>
          </div>
        </>
      );
      // console.log(item, index, id, tab, tabDetail)
    });
  }else{
    return (<></>);
  }

  useEffect(() => {
    let ideaSwiper = {};
    for (let i = 1; i <= IdeaDec.length; i++) {
      let thumbs = new Swiper(`#idea-thumb-${i}`, {
        slidesPerView: "auto",
        initialSlide: 1,
        spaceBetween: 8,
        loop: true,
        pagination: {
          el: ".gallery-sm-pagi",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        threshold: 20,
      });

      let slider = new Swiper(`#idea-slide-${i}`, {
        slidesPerView: "auto",
        initialSlide: 1,
        spaceBetween: 10,
        centeredSlides: true,
        autoHeight: true,
        loop: true,
        thumbs: {
          swiper: thumbs,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });

      ideaSwiper[`idea-swiper-${i}`] = new Swiper(`#idea-swiper-${i}`, {
        zoom: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1025: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
        pagination: {
          el: ".g-page",
          type: "fraction",
        },
      });
    }

    $(".idea-list").on("click", function () {
    let idElm = $(this).attr("id");
    let slideIndex = $("#" + idElm)
      .find(".swiper-slide-active")
      .data("swiper-slide-index");

    let slideName = "";
    if (idElm === "idea-slide-1") {
      slideName = ideaSwiper[`idea-swiper-1`];
    } else if (idElm === "idea-slide-2") {
      slideName = ideaSwiper[`idea-swiper-2`];;
    } else if (idElm === "idea-slide-3") {
      slideName = ideaSwiper[`idea-swiper-3`];;
    }

    slideName.slideTo(slideIndex);

    $("#idea-modal").addClass("active");
    $("body").addClass("lock-scrolling");
  });
  }, [IdeaDec]);

  console.log("PropertyNearByTabList render", IdeaDec);

  return (
    <>
      <div id="idea-decoration" className="idea-decoration-wrapper">
        <h2>ไอเดียสำหรับการตกแต่ง</h2>
        <div
          id="tab-2"
          className="g-tab-toggle-content pxtm-click-toggleDetail"
          title="แสดงหมวดหมู่ทั้งหมด"
        >
          <div className="g-tab-toggle-inner">
            <div className="g-tab-toggle">
              <ul className="g-tab-wrapper">{tab}</ul>
            </div>
            <button type="button" className="g-tab-button">
              <i className="g-tab-arrow" />
            </button>
            <div className="g-float" />
          </div>
          <div className="g-tab-content">{tabDetail}</div>
        </div>
      </div>
      {/* Idea Modal */}
      <div id="idea-modal" className="gallery-backdrop">
        <div className="line-modal" />
        <div className="g-wrapper-col">
          <div className="g-modal-header mb">
            <h2>ไอเดียสำหรับการตกแต่ง</h2>
            <button type="button" className="close-gallery-modal">
              <img
                src="/SiteCollectionDocuments/assets/PFS2022/theme/img/icon/close-filter.svg"
                alt="close"
              />
            </button>
          </div>
          <div className="g-body">
            <div className="g-wrapper-col-l">
              <div className="g-tab">
                <div id="tab-idea" className="g-tab-toggle-content">
                  <div className="g-tab-toggle-inner">
                    <div className="g-tab-toggle">
                      <ul className="g-tab-wrapper">{tab}</ul>
                    </div>
                    <button type="button" className="g-tab-button" style={{ display: "none" }}>
                      <i className="g-tab-arrow" />
                    </button>
                    <div className="g-float" />
                  </div>
                  <div className="g-tab-content">{tabModal}</div>
                </div>
              </div>
            </div>
            <ModalDetail
              propertyDetail={propertyDetail}
              title="ไอเดียสำหรับการตกแต่ง"
              makeAnOfferClick={props.makeAnOfferClick}
              isDecoration={true}
            />
          </div>
        </div>
      </div>
    </>
  );
}, areNearbyPlacesEqual);

function areNearbyPlacesEqual(prevProps, nextProps) {
  if (prevProps.propertyDetail?.AIImg?.length !== nextProps.propertyDetail?.AIImg?.length) {
    return false;
  }
  return true;
}
